import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ValidationErrorItem } from '../../models/validation-error-item';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss',
  standalone: false,
})
export class MessageComponent implements OnChanges {
  @Input() message: string = '';
  @Input() isTemporary: boolean = true
  @Input() exibitionTime = 3000;
  @Input() kind: 'success' | 'error' = 'success';
  @Input() variable?: Record<string, string> = {};
  @Input() errors?: ValidationErrorItem[];

  @Output() messageCleared = new EventEmitter<void>();

  show = true;

  ngOnChanges() {
    if (this.errors?.length) {
      this.isTemporary = false;
      this.show = true;
    } else {
      this.isTemporary = true;
    }
    if (this.kind === 'success') {
      this.errors = [];
    }
    if (this.isTemporary) {
      this.clearMessagesAfterDelay();
    }
  }

  close() {
    this.show = false;
    this.errors = [];
    this.messageCleared.emit();
  }

  private clearMessagesAfterDelay() {
    setTimeout(() => {
      this.close();
    }, this.exibitionTime);
  }
}
